<template>
    <modal size="lg" :height-max="true" @close="$emit('close')" ref="modal" :is-closeable="isCloseable" :autoshow="true">
        <template v-slot:title>
            <h3 class="modal-title">Availability</h3>
        </template>

        <slot>
            <div class="mb-2">
                <div class="p-1 unpad-x bg-150 rounded">
                    <div><span class="text-muted">Plan: </span>{{ clientPlan.accrual_plan.name }}</div>
                </div>
            </div>

            <positions-fields v-model:all-positions="formData.all_positions" v-model:positions="formData.positions" :client="client" :errors="errors" />
        </slot>

        <template v-slot:footer>
            <form-errors :errors="formErrors"/>

            <button-row stacked>
                <button type="button" class="btn btn-outline-primary" @click.prevent="close()">Cancel</button>
                <button type="button" class="btn btn-primary" @click.prevent="onSubmit()">Save</button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'
import PositionsFields from './PositionsFields'

export default {
    props: ['client', 'clientPlan', ],
    mixins: [FormMixin, ModalMixin],
    emits: ['close', 'updated', ],
    components: {PositionsFields, },
    data() {
        return {
            formData: {
                all_positions: this.clientPlan.all_positions,
                positions: this.clientPlan.positions.map(p => p.id),
            },
        }
    },
    methods: {
        onSubmit() {
            this.$store.dispatch('START_LOADING')
            return this.$api.put(`/clients/${this.client.id}/settings/accrual-plans/${this.clientPlan.id}`, this.getFormData()).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$emit('updated', resp)
                this.close()
            }).catch(errors => {
                this.$store.dispatch('STOP_LOADING')
                this.errors = errors
                this.formErrors = errors.__all__
                this.onError()
            })
        },
    },
}
</script>
